import { lazy } from "react";

// project imports
import MainLayout from "layout/MainLayout";
import { Navigate } from 'react-router-dom';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';
import Calls from 'views/calls';
import ApproveBusinessApp from 'views/dashboard/Business/approveBusinessApp';
import SampleResponse from 'views/SampleResponse';
import SettlementAccount from 'views/settlement-account';
import UsersDetails from 'views/usersDetails';
import CallsDetails from 'views/callsDetails';
import BusinessDetails from 'views/usersDetails';
import HistoryList from 'views/calls/HistoryList';
import ErrorTable from 'views/errors/errorTable';
import AdminUser from 'views/admin-user';
import Smedan from 'views/smedan';

// dashboard routing
const DashboardDefault = Loadable(
  lazy(() => import('views/dashboard/Default'))
);
const DashboardAnalytics = Loadable(
  lazy(() => import('views/dashboard/Analytics'))
);
const CustomerCallsTab = Loadable(
  lazy(() => import('views/dashboard/Analytics/CustomerCallsTab')),
);
const DashboardBusiness = Loadable(
  lazy(() => import('views/dashboard/Business'))
);
const RevenueDashboard = Loadable(
  lazy(() => import('views/dashboard/Revenue'))
);
const Reports = Loadable(lazy(() => import('views/reports')));

const TestBanks = Loadable(lazy(() => import('views/testBanks')));
const VerificationUpload = Loadable(
  lazy(() => import('views/verification-upload'))
);
const ConsentDrilldown = Loadable(
  lazy(() => import('views/dashboard/Analytics/ConsentDrilldown'))
);
// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: '/dashboard',
      element: <DashboardDefault />,
    },
    {
      path: '/consent-drilldown',
      element: <ConsentDrilldown />,
    },
    {
      path: '/customer-dashboard',
      element: <DashboardAnalytics />,
    },
    {
      path: '/count-dashboard',
      element: <CustomerCallsTab />,
    },
    {
      path: '/business-dashboard',
      element: <DashboardBusiness />,
    },
    {
      path: '/admin',
      element: <DashboardBusiness />,
    },
    {
      path: '/revenue-dashboard',
      element: <RevenueDashboard />,
    },
    {
      path: '/business-dashboard/app-approve',
      element: <ApproveBusinessApp />,
    },
    {
      path: '/admin/app-approve',
      element: <ApproveBusinessApp />,
    },
    // {
    //   path: '/reports',
    //   element: <Reports />,
    // },
    {
      path: '/api-business-partner',
      element: <DashboardBusiness />,
    },

    {
      path: '/api-business-partner/app-approve',
      element: <ApproveBusinessApp />,
    },

    {
      path: '/sample-bank-response',
      element: <SampleResponse />,
    },
    {
      path: '/test-banks',
      element: <TestBanks />,
    },
    {
      path: '/settlement-account',
      element: <SettlementAccount />,
    },
    {
      path: '/smedan',
      element: <Smedan />,
    },
    {
      path: '/upload-verification',
      element: <VerificationUpload />,
    },
    {
      path: '/calls',
      element: <Calls />,
    },

    {
      path: '/errors/:tableName',
      element: <ErrorTable />,
    },
    {
      path: '/calls/:id',
      element: <CallsDetails />,
    },
    {
      path: 'calls/:id/users',
      element: <HistoryList />,
    },
    {
      path: '/business-details/:id',
      element: <BusinessDetails />,
    },
    {
      path: '/admin-user',
      element: <AdminUser />,
    },
    { path: '*', element: <Navigate to="/dashboard" replace /> },
  ],
};

export default MainRoutes;
